import { API_URL } from '../config/api';

// Web'in API isteklerine oturum token'ını ekler: uygulamadaki yüzlerce fetch çağrısı tek tek
// değiştirilmeden backend'in kimlik doğrulaması desteklenir (bkz. backend/apiAuth.js).
// iOS WebView sayfalarında token localStorage'da değil, uygulamanın sayfaya enjekte ettiği
// window.__akikAuthToken'dadır (KasaOzetiView.swift).

const getToken = () => {
  if (window.__akikAuthToken) return window.__akikAuthToken;
  try {
    return localStorage.getItem('token');
  } catch {
    return null;
  }
};

const isApiUrl = (url) => {
  try {
    const target = new URL(url, window.location.origin);
    const base = new URL(API_URL, window.location.origin);
    const basePath = base.pathname.replace(/\/$/, '');
    return target.origin === base.origin && (target.pathname === basePath || target.pathname.startsWith(`${basePath}/`));
  } catch {
    return false;
  }
};

// Header gönderemeyen istekler (EventSource, indirme linki) için; backend bu uçlarda ?token= kabul eder
export const withApiToken = (url) => {
  const token = getToken();
  if (!token) return url;
  return `${url}${url.includes('?') ? '&' : '?'}token=${encodeURIComponent(token)}`;
};

export const installApiAuth = () => {
  if (window.__akikApiAuthInstalled) return;
  window.__akikApiAuthInstalled = true;

  // iOS WebView sayfaları giriş yapmadığı için sunucunun /uploads fotoğraf çerezi (akik_uploads_token)
  // hiç kurulmuyor ve <img src="/uploads/..."> 401 alıyor. Uygulamanın enjekte ettiği token ile aynı
  // çerezi burada kuruyoruz (backend: requireUploadAuth). Web'de window.__akikAuthToken yoktur.
  if (window.__akikAuthToken) {
    try {
      document.cookie = `akik_uploads_token=${encodeURIComponent(window.__akikAuthToken)}; path=/uploads; max-age=${30 * 24 * 60 * 60}; secure; samesite=lax`;
    } catch {
      // çerez yazılamazsa fotoğraflar uygulamanın kurduğu çerezle gelir
    }
  }
  const originalFetch = window.fetch.bind(window);

  window.fetch = (input, init) => {
    const url = typeof input === 'string' ? input : (input instanceof URL ? input.href : input?.url);
    const token = getToken();
    if (!token || !url || !isApiUrl(url)) return originalFetch(input, init);

    const headers = new Headers(init?.headers || (input instanceof Request ? input.headers : undefined));
    if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${token}`);
    return originalFetch(input, { ...init, headers }).then((response) => {
      // Backend oturumu kabul etmedi (token süresi doldu / iptal edildi): App giriş ekranına döner
      if (response.status === 401 && response.headers.get('X-Auth-Required') === '1') {
        window.dispatchEvent(new CustomEvent('akik:unauthorized'));
      }
      return response;
    });
  };
};
